import React from 'react'
import ConfigProvider from '../../store/ConfigContext'
import OobeBar from './OobeBar'

const OobeLayout = (props) => {
  return (
    <ConfigProvider {...props}>
      <OobeBar />
    </ConfigProvider>
  )
}

export default OobeLayout
